var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5794 13.5281L5.44891 16.196C4.51408 16.3608 3.62265 15.7366 3.45782 14.8018L1.79236 5.35655C1.62753 4.42173 2.25173 3.5303 3.18652 3.36547L18.317 0.69754C19.2518 0.532712 20.1433 1.15692 20.3081 2.0917L21.9736 11.537C22.1384 12.4717 21.5142 13.3632 20.5794 13.5281Z",
    fill: "#3555A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.317 0.69754L10.7518 2.03146L13.0142 14.862L20.5794 13.5281C21.5142 13.3632 22.1384 12.4717 21.9736 11.537L20.3081 2.0917C20.1433 1.15692 19.2518 0.532712 18.317 0.69754Z",
    fill: "#1B3555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 19.3288H1.71875C0.769527 19.3288 0 18.5593 0 17.6101V8.25501C0 7.30579 0.769527 6.53626 1.71875 6.53626H16.7578C17.707 6.53626 18.4766 7.30579 18.4766 8.25501V17.6101C18.4766 18.5593 17.707 19.3288 16.7578 19.3288Z",
    fill: "#53D8E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 6.53626H9.23828V19.3288H16.7578C17.707 19.3288 18.4766 18.5593 18.4766 17.6101V8.25501C18.4766 7.30579 17.707 6.53626 16.7578 6.53626Z",
    fill: "#18A8C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.46029H18.4766V12.3843H0V9.46029Z",
    fill: "#ECF6FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11702 16.4913H2.193C1.83704 16.4913 1.54846 16.7798 1.54846 17.1358C1.54846 17.4917 1.83704 17.7803 2.193 17.7803H5.11702C5.47297 17.7803 5.76155 17.4917 5.76155 17.1358C5.76155 16.7798 5.47297 16.4913 5.11702 16.4913Z",
    fill: "#EAF6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23828 9.46029H18.4766V12.3843H9.23828V9.46029Z",
    fill: "#D6E8FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.b94e1588eafb7d7727fd6aef772d3663.svg";
export { ForwardRef as ReactComponent };